<template>
  <div v-if="bgWidth < 100" :class="'loading ' + loading.class_name" :style="getSimulatorBodyStyle(loading.background)">
    <div class="loading-header">
      <img v-if="loading.image" :src="loading.image" :style="'width: ' + loading.image_width + ';'" />
    </div>
    <div class="loading-progress">
      <div class="loading-progress-inner">
        <div class="loading-progress-bg" :style="'width: ' + bgWidth + '%; height: 20px;'">
        </div>
      </div>
    </div>
    <div class="loading-text">{{ loading.text }}</div>
  </div>
</template>
<script>
import { getSimulatorBodyStyle } from '@/libs/tool'

export default {
  name: 'ElementsLoading',
  components: {
  },
  props: {
    images: [],
    loading: {}
  },
  data () {
    return {
      bgWidth: 5,
      loadingNumber: 0
    }
  },
  computed: {
  },
  watch: {
  },
  methods: {
    getSimulatorBodyStyle (background) {
      return getSimulatorBodyStyle(background)
    },
    refProgress () {
      var bgWidth = 95 / this.images.length * this.loadingNumber + 5
      if (bgWidth >= 100) {
        setTimeout(() => {
          this.bgWidth = bgWidth
        }, 900)
      } else {
        this.bgWidth = bgWidth
      }
    },
    loadingImage () {
      var me = this
      for (var idx in this.images) {
        var img = new Image()
        img.src = this.images[idx]
        img.onload = function () {
          me.loadingNumber++
          me.refProgress()
        }
      }
    }
  },
  mounted () {
    this.loadingImage()
  }
}
</script>
<style>
.loading { position: absolute; width: 100%; height: 100%; top: 0; left: 0; padding: 40% 10%; z-index: 99999; }
</style>



// WEBPACK FOOTER //
// src/components/ui/loading.vue